import type { Locale } from "utils/dateFormat";
import type { ReplyMute } from "types/ReplyMute";
import { replyMuteLabel } from "utils/replyMuteLabel";

export function ReplyMuteBadge({
  mute,
  locale,
}: {
  mute?: ReplyMute | null;
  locale: Locale;
}) {
  const label = replyMuteLabel(mute, locale);
  if (!label) return null;
  return (
    <div className="truncate text-[10px] font-medium text-amber-700" title={label}>
      {label}
    </div>
  );
}
